// extracted by mini-css-extract-plugin
export default {"container":"FilterDropdownMenu-module__container___mQfUp","toggle":"FilterDropdownMenu-module__toggle___FqLG9"};